import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import {
  ListItemSecondaryAction,
  ListItemAvatar,
  IconButton,
  Typography,
  Card,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { getDocDetails } from "../../../../redux/docs";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
const detailList = [
  {
    title: "Type",
    key: "type",
  },
  {
    title: "MLS Number",
    key: "mls_listing_id",
    defaultValue: "",
  },
  // {
  //   title: "Owner:Group",
  //   key: "owner-group",
  //   defaultValue: "(GAAR01) Method Real Estate Advisors",
  // },
  {
    title: "Owner:User",
    key: "owner",
    defaultValue: "Peter Marks",
  },
  // {
  //   title: "Status",
  //   key: "status",
  //   defaultValue: "Active",
  // },
  // {
  //   title: "Permissions",
  //   key: "Permissions",
  //   defaultValue: "Editable",
  // },
  {
    title: "Created",
    key: "created_at",
  },
  {
    title: "Contents",
    key: "forms",
  },
];

function InfoDetail(props) {
  const { open, setOpen, classes, folderDetails } = props;
  const [value, setValue] = React.useState("1");
  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const docDetail = useSelector((item) => item.Docs.docDetail);
  const usersList = useSelector((item) => item.users.storedListOfUsers?.list);
  console.log(folderDetails, "folderDetails");

  useEffect(() => {
    if (open && folderDetails?.id) {
      dispatch(getDocDetails({ id: folderDetails?.id }));
    }
  }, [open, folderDetails?.id]);

  console.log(docDetail, "docDetail");

  return (
    <Drawer
      open={open}
      anchor={"right"}
      disablePortal
      onClose={toggleDrawer(false)}
      sx={{
        "& .MuiBackdrop-root": {
          background: "transparent",
        },
        "& .MuiPaper-root": {
          background: "#f0eff2",
          mt: "64px",
          boxShadow: "-1px 0 0 0 #729BE9",
        },
      }}
    >
      {console.log(folderDetails, "folderDetails")}
      <Box sx={{ width: "340px", p: 2 }} role="presentation">
        <List>
          {" "}
          <ListItem disablePadding>
            <ListItemAvatar sx={{ minWidth: "40px" }}>
              {folderDetails?.type === "folder" ? (
                <FolderOpenOutlinedIcon />
              ) : (
                <DescriptionOutlinedIcon />
              )}
            </ListItemAvatar>
            <ListItemText
              classes={{
                primary: classes.detailHeading,
                secondary: classes.detailCaption,
              }}
              primary={folderDetails?.name || folderDetails?.forms_data?.name}
              secondary={folderDetails?.type}
            />
            <ListItemSecondaryAction
              sx={{
                marginRight: "-20px !important",
                mt: "-20px !important",
                padding: "0px !important",
              }}
            >
              <IconButton onClick={toggleDrawer(false)} size="small">
                <CloseRoundedIcon fontSize="small" />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>{" "}
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box
              className={classes.tabsContainer}
              sx={{ borderBottom: 1, borderColor: "#2868D7" }}
            >
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Detail" value="1" />
                <Tab label="Activity" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" sx={{ padding: "12px 6px" }}>
              <Box className={classes.tabDetail}>
                {detailList?.map((it) => (
                  <Box className={classes.tabDetailItem}>
                    <Typography className={classes.tabDetailItemLabel}>
                      {it?.title}
                    </Typography>
                    <Typography className={classes.tabDetailItemValue}>
                      {it?.key === "created_at" && folderDetails?.[it.key]
                        ? moment(folderDetails?.[it.key]).format("L")
                        : it?.key === "forms" && docDetail?.data?.forms
                        ? docDetail?.data?.forms?.length
                        : it?.key === "owner" &&
                          folderDetails?.[it.key] &&
                          usersList?.find(
                            (it) => it.id === folderDetails?.[it.key]
                          )
                        ? usersList?.find(
                            (it) => it.id === folderDetails?.[it.key]
                          )?.first_name
                        : it?.key === "owner"
                        ? it?.defaultValue
                        : folderDetails?.[it.key] || it?.defaultValue || ""}
                    </Typography>
                  </Box>
                ))}
              </Box>
              <Divider />
              <Typography className={classes.subHeading}>
                {folderDetails?.type === "folder" ? "Contents" : "People"}{" "}
              </Typography>
              {docDetail?.isLoading ? (
                <Box
                  sx={{
                    width: "100%",
                    height: "300px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress size={30} />
                </Box>
              ) : (
                <Box className={classes.contentContainer}>
                  {folderDetails?.type === "folder" ? (
                    docDetail?.data?.forms?.length ? (
                      docDetail?.data?.forms?.map((item, index) => (
                        <Box className={classes.contentItem} key={index}>
                          {item?.forms_data?.file?.includes("pdf") ? (
                            <PictureAsPdfOutlinedIcon fontSize="small" />
                          ) : (
                            <DescriptionOutlinedIcon fontSize="small" />
                          )}
                          <Typography className={classes.tabDetailItemValue}>
                            {item?.forms_data?.name}
                          </Typography>
                        </Box>
                      ))
                    ) : null
                  ) : (
                    <Box className={classes.contentContainer}>
                      {docDetail?.data?.buyers?.length
                        ? docDetail?.data?.buyers?.map((buyer, index) => (
                            <Box
                              key={buyer.id}
                              className={classes.peopleAvatarContainer}
                            >
                              <Avatar sx={{ width: "26px", height: "26px" }} />
                              <Box
                                className={classes.activityAvatarDecContainer}
                              >
                                <Typography
                                  className={
                                    classes.peopleAvatarDecContainerHeading
                                  }
                                >
                                  {buyer?.first_name} {buyer?.last_name}{" "}
                                </Typography>
                                <Typography
                                  className={
                                    classes.peopleAvatarDecContainerCaption
                                  }
                                >
                                  Buyer
                                </Typography>
                              </Box>
                            </Box>
                          ))
                        : null}
                      {docDetail?.data?.buyer_brokers?.length
                        ? docDetail?.data?.buyer_brokers?.map(
                            (buyer, index) => (
                              <Box
                                key={buyer.id}
                                className={classes.peopleAvatarContainer}
                              >
                                <Avatar
                                  sx={{ width: "26px", height: "26px" }}
                                />
                                <Box
                                  className={classes.activityAvatarDecContainer}
                                >
                                  <Typography
                                    className={
                                      classes.peopleAvatarDecContainerHeading
                                    }
                                  >
                                    {buyer?.first_name} {buyer?.last_name}{" "}
                                  </Typography>
                                  <Typography
                                    className={
                                      classes.peopleAvatarDecContainerCaption
                                    }
                                  >
                                    Buyer Broker
                                  </Typography>
                                </Box>
                              </Box>
                            )
                          )
                        : null}
                      {docDetail?.data?.sellers?.length
                        ? docDetail?.data?.sellers?.map((buyer, index) => (
                            <Box
                              key={buyer.id}
                              className={classes.peopleAvatarContainer}
                            >
                              <Avatar sx={{ width: "26px", height: "26px" }} />
                              <Box
                                className={classes.activityAvatarDecContainer}
                              >
                                <Typography
                                  className={
                                    classes.peopleAvatarDecContainerHeading
                                  }
                                >
                                  {buyer?.first_name} {buyer?.last_name}{" "}
                                </Typography>
                                <Typography
                                  className={
                                    classes.peopleAvatarDecContainerCaption
                                  }
                                >
                                  Seller
                                </Typography>
                              </Box>
                            </Box>
                          ))
                        : null}
                      {docDetail?.data?.seller_brokers?.length
                        ? docDetail?.data?.seller_brokers?.map(
                            (buyer, index) => (
                              <Box
                                key={buyer.id}
                                className={classes.peopleAvatarContainer}
                              >
                                <Avatar
                                  sx={{ width: "26px", height: "26px" }}
                                />
                                <Box
                                  className={classes.activityAvatarDecContainer}
                                >
                                  <Typography
                                    className={
                                      classes.peopleAvatarDecContainerHeading
                                    }
                                  >
                                    {buyer?.first_name} {buyer?.last_name}{" "}
                                  </Typography>
                                  <Typography
                                    className={
                                      classes.peopleAvatarDecContainerCaption
                                    }
                                  >
                                    Seller Broker
                                  </Typography>
                                </Box>
                              </Box>
                            )
                          )
                        : null}
                    </Box>
                  )}
                  {}
                </Box>
              )}
            </TabPanel>
            <TabPanel value="2" sx={{ padding: "12px 6px" }}>
              <Box className={classes.activityContainer}>
                <Typography className={classes.activityHeading}>
                  CO16 - Referral Agreement (Broker to Broker)
                </Typography>
                <Card className={classes.activityCard}>
                  <Box className={classes.activityItem}>
                    <Box className={classes.activityItemBadge}>
                      Smart Form - Draft (current)
                    </Box>
                    <Typography className={classes.activityItemDate}>
                      06-05-2025 12:14 p.m. EDT
                    </Typography>
                  </Box>
                  <Box className={classes.activityItem}>
                    <Box className={classes.activityAvatarContainer}>
                      <Avatar sx={{ width: "20px", height: "20px" }} />
                      <Box className={classes.activityAvatarDecContainer}>
                        <Typography
                          className={classes.activityAvatarDecContainerHeading}
                        >
                          Peter Marks
                        </Typography>
                        <Typography
                          className={classes.activityAvatarDecContainerCaption}
                        >
                          Owner
                        </Typography>
                      </Box>
                    </Box>
                    <Box className={classes.activityCardRight}>
                      <Button
                        variant="text"
                        size="small"
                        className={classes.activityCardDetail}
                      >
                        See Details
                      </Button>
                    </Box>
                  </Box>
                </Card>
              </Box>
            </TabPanel>
          </TabContext>
        </Box>
        <Divider />
      </Box>
    </Drawer>
  );
}

export default withStyles(styleSheet, { name: "InfoDetailStyle" })(InfoDetail);
